import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'

export const useCustomerGroups = (guest) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const customAPIFolderName = 'customer-groups'
    const apiPath = `get-customer-groups?`

    return useQuery({
        queryKey: ['custom', 'customer-groups'],
        queryFn: () =>
            doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName,
                apiPath
            }),
        enabled: guest,
        stale: 0,
        cache: 0
    })
}
